"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationBadge = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var NotificationBadge = function (_a) {
    var className = _a.className, color = _a.color, counter = _a.counter, dark = _a.dark, _b = _a.hiddenText, hiddenText = _b === void 0 ? 'unread notifications' : _b, href = _a.href, label = _a.label, onClick = _a.onClick;
    var Tag = href ? 'a' : onClick ? 'button' : 'div';
    return ((0, jsx_runtime_1.jsxs)(Tag, __assign({ "data-testid": "notification-badge", className: (0, classnames_1.default)('notification-badge', dark && 'notification-badge-dark', Tag === 'button' && 'border-0', Tag === 'a' && 'text-decoration-none', className), type: Tag === 'button' ? 'button' : undefined, href: Tag === 'a' && href ? href : undefined, onClick: onClick }, { children: [label, ' ', (0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "notification-badge-counter", className: (0, classnames_1.default)('notification-badge-counter', color ? "bg-".concat(color) : 'notification-badge-counter-neutral') }, { children: counter })), (0, jsx_runtime_1.jsx)("span", __assign({ "data-testid": "hidden-text", className: "visually-hidden" }, { children: hiddenText }))] })));
};
exports.NotificationBadge = NotificationBadge;
